/**
 * NEXT_PUBLIC_ENABLE_ENTERPRISE_LOGIN — when not exactly "true", all enterprise UI and
 * /enterprise/*, /enterprise-auth (legacy redirect), and recruiter short links are disabled (see middleware).
 */

export function isEnterpriseLoginEnabled(): boolean {
  return process.env.NEXT_PUBLIC_ENABLE_ENTERPRISE_LOGIN === 'true'
}

/**
 * When true, /enterprise/sign-in shows email OTP + Log in / Register tabs (local dev).
 * When false or unset (e.g. production), show Google + Microsoft SSO only.
 */
export function isEnterpriseAuthLocalFullFeatures(): boolean {
  return process.env.NEXT_PUBLIC_LOCAL_ENV === 'true'
}

function pathnameOnly(path: string): string {
  const noHash = path.split('#')[0] ?? ''
  const noQuery = noHash.split('?')[0] ?? ''
  return noQuery.trim() || '/'
}

/** True for legacy /enterprise-auth, /enterprise, or any /enterprise/... path. */
export function redirectPathTargetsEnterprise(path: string): boolean {
  const p = pathnameOnly(path)
  return (
    p === '/enterprise-auth' ||
    p === '/enterprise' ||
    p.startsWith('/enterprise/')
  )
}
